import { render } from "./TheFooter3.vue?vue&type=template&id=0e239960&scoped=true"
import script from "./TheFooter3.vue?vue&type=script&lang=js"
export * from "./TheFooter3.vue?vue&type=script&lang=js"

import "./TheFooter3.vue?vue&type=style&index=0&id=0e239960&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e239960"]])

export default __exports__